let snackbarInstance = null

export function setSnackbarInstance(instance) {
  snackbarInstance = instance
}

export function showSnackbar(options) {
  if (snackbarInstance) {
    snackbarInstance.showSnackbar(options)
  } else {
    console.warn('Snackbar não está inicializado. Certifique-se de registrar o componente GlobalSnackbar.')
  }
}

export function showSuccess(message, timeout = 3000) {
  if (snackbarInstance) {
    snackbarInstance.success(message, timeout)
  } else {
    console.warn('Snackbar não está inicializado.')
  }
}

export function showError(message, timeout = 4000) {
  if (snackbarInstance) {
    snackbarInstance.error(message, timeout)
  } else {
    console.warn('Snackbar não está inicializado.')
  }
}

export function showWarning(message, timeout = 3500) {
  if (snackbarInstance) {
    snackbarInstance.warning(message, timeout)
  } else {
    console.warn('Snackbar não está inicializado.')
  }
}

export function showInfo(message, timeout = 3000) {
  if (snackbarInstance) {
    snackbarInstance.info(message, timeout)
  } else {
    console.warn('Snackbar não está inicializado.')
  }
}

export function showSuccessWithAction(message, timeout = -1) {
  if (snackbarInstance) {
    snackbarInstance.successWithAction(message, timeout)
  } else {
    console.warn('Snackbar não está inicializado.')
  }
}
